import defaultPassport from '@/constants/instalationPassport/defaultPassport'

export default defaultPassport
